
const isLive = true;

const BASE_URL = isLive
  ? 'https://marketapi.ruhiverse.com/index.php/api'
  : 'http://localhost:8000/api';

export default BASE_URL;
